import { Call } from "@mui/icons-material";
import { Grid, Toolbar, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function NavbarLayout({ showNavbar, phoneNumber }) {

    var navi = useNavigate();

    function splitCC(number) {
        return number.slice(-10)
    }

    return (
        <>

            {/* <Grid bgcolor={'#7A1F1F'} className='position-sticky z-5 top-0'> */}
            {/* <Grid bgcolor={'#DBE6EC'} className='position-sticky z-5 top-0'> */}
            {/* <Grid bgcolor={'#3A2B2B'} className='position-sticky z-5 top-0'> */}
            {/* <Grid bgcolor={'#5F7470'} className=' z-5 top-0'> */}
            <Grid bgcolor={'rgb(99, 130, 221)'} position={'sticky'} top={0} className=' z-5 top-0'>
                <Toolbar>
                    <Typography variant="h5" fontWeight={'bold'} fontFamily={'RoobertPRO'} color="white">BookYourSalon</Typography>
                    <Grid flexGrow={1}></Grid>
                    {showNavbar && (

                        <a href={`tel:${phoneNumber}`} className="text-white text-decoration-none h-100">
                            <button className="btn btn-navy fadeIn px-4">
                                <Typography fontSize={16}><Call /> <span className="ms-3">+91</span>&nbsp;&nbsp;{splitCC(phoneNumber.replace(/\D/g, ""))}</Typography>
                            </button>
                        </a>
                    )}
                </Toolbar>
            </Grid>

        </>
    )

}